/* Rorilio · moteur d'offres unique (28/10). Remplace rorilio-bogo-units.js, rorilio-esc-gift.js et les 9 scripts *-cart.js.
   Source unique : offers.json -> snippets/rorilio-offers-config.liquid (JSON généré, ne pas éditer à la main).
   Règles (Cédric 28/10) : prix = combinaison de packs la moins chère pour la quantité totale du produit ; MEXIQUE seulement :
   hors MXN (ex. COP) aucun code n'est posé (les codes gérés sont retirés, ceux du client restent) ; 1 code par offre (Shopify ne cumule pas 2 codes sur le même produit, 5 codes max par panier) ;
   les codes saisis par le client (hors liste "managed") ne sont jamais retirés ; une seule réconciliation calcule tout le panier
   (normalisation des anciennes lignes pack/produit caché -> tubes réels, cadeaux, codes) puis écrit une fois (/cart/update.js),
   précédé d'un /cart/add.js seulement si une ligne doit être créée avec des propriétés (cadeau SD, tons). */
(function (root) {
  'use strict';

  /* ---------- coeur pur (testé en Node par bench/run_bench.py) ---------- */
  var MAX_CODES = 5;
  function upper(c) { return String(c || '').trim().toUpperCase(); }
  function codeFor(offer, q, currency) {
    var arr = offer.plan && offer.plan[currency];
    if (!arr || !q) return '';
    return q < arr.length - 1 ? arr[q] : arr[arr.length - 1]; /* dernière case = au-delà du plafond */
  }
  function tonesOf(line) {
    var out = [], p = line.properties || {};
    for (var n = 1; n <= line.quantity; n++) out.push(p['Tono ' + n] || p['Tono 1'] || '');
    return out;
  }
  function repeatProps(p, times) { /* couleurs d'un pack répétées par pack (Rímel « Colores ») */
    if (!p) return null; var out = {};
    Object.keys(p).forEach(function (k) { out[k] = k === 'Colores' ? Array(times).fill(p[k]).join(', ') : p[k]; });
    return out;
  }
  function plan(cart, cfg) {
    var offers = cfg.offers || [], currency = upper(cart.currency);
    var managed = {}; (cfg.managed || []).forEach(function (c) { managed[upper(c)] = 1; });
    var byUnit = {}, byNorm = {}, giftIds = {};
    offers.forEach(function (o) {
      Object.keys(o.units || {}).forEach(function (v) { byUnit[v] = o; });
      Object.keys(o.normalize || {}).forEach(function (v) { byNorm[v] = o; });
      (o.gifts || []).forEach(function (g) { giftIds[g.variant] = 1; });
    });
    var retired = {}; (cfg.retired_variants || []).forEach(function (v) { retired[v] = 1; });
    var updates = {}, adds = [], qty = {}, unitQty = {}, lines = cart.items || [];
    function bump(vid, n) { unitQty[vid] = (unitQty[vid] || 0) + n; }
    /* 1. normalisation : variantes pack et lignes "unidad-bogo" -> tubes réels au prix normal */
    lines.forEach(function (l) {
      var v = String(l.variant_id), o = byNorm[v];
      if (retired[v]) { updates[l.key] = 0; return; }
      if (!o) { if (byUnit[v] && !l.selling_plan_allocation) bump(v, l.quantity); return; } /* abonnements exclus (Cédric 28/10) */
      var rule = o.normalize[v];
      updates[l.key] = 0;
      if (Array.isArray(rule)) rule.forEach(function (r) { var n = r[1] * l.quantity; if (n) { adds.push({ id: Number(r[0]), quantity: n, offer: o.id, properties: repeatProps(r[2], l.quantity) }); bump(String(r[0]), n); } });
      else { /* ancien produit caché : 1 tube par unité, ton lu dans "Tono n" */
        var counts = {};
        tonesOf(l).forEach(function (t) { var u = String(rule.tones[t] || o.unit); counts[u] = (counts[u] || 0) + 1; });
        Object.keys(counts).forEach(function (u) { adds.push({ id: Number(u), quantity: counts[u], offer: o.id }); bump(u, counts[u]); });
      }
    });
    Object.keys(unitQty).forEach(function (vid) { var o = byUnit[vid]; qty[o.id] = (qty[o.id] || 0) + unitQty[vid] * (o.units[vid] || 1); });
    /* fusionner les ajouts de tubes dans une ligne existante simple du même tube */
    var merged = [];
    adds.forEach(function (a) {
      if (a.properties) { merged.push({ id: a.id, quantity: a.quantity, properties: a.properties }); return; } /* ex. Rímel : couleurs en propriété */
      var same = lines.filter(function (l) { return l.variant_id === a.id && updates[l.key] !== 0 && !Object.keys(l.properties || {}).length; })[0];
      if (same) updates[same.key] = (updates[same.key] != null ? updates[same.key] : same.quantity) + a.quantity;
      else {
        var m = merged.filter(function (x) { return x.id === a.id && !x.properties; })[0];
        if (m) m.quantity += a.quantity; else merged.push({ id: a.id, quantity: a.quantity });
      }
    });
    /* 2. cadeaux (vraies lignes, offerts par la remise auto "Regalos GRATIS" ou par un code) */
    var wanted = [];
    offers.forEach(function (o) {
      var q = qty[o.id] || 0;
      (o.gifts || []).forEach(function (g) {
        var need = 0;
        if (g.per_unit) Object.keys(g.per_unit).forEach(function (v) { need += (unitQty[v] || 0) * g.per_unit[v]; });
        else need = q >= g.min && (g.max == null || q <= g.max) ? g.qty : 0; /* max optionnel (30/10, Paño : Mini 6-11 seulement) */
        var have = lines.filter(function (l) { return l.variant_id === g.variant; });
        if (have.length) have.forEach(function (l, i) { var w = i === 0 ? need : 0; if (l.quantity !== w) updates[l.key] = w; });
        else if (need) merged.push(g.props ? { id: g.variant, quantity: need, properties: g.props } : { id: g.variant, quantity: need });
        if (need && g.code) wanted.push(upper(g.code));
      });
      if (o.engine === 'codes') { var c = codeFor(o, q, currency); if (c) wanted.push(upper(c)); }
    });
    /* 3. codes : ceux du client d'abord (jamais retirés), puis les nôtres dans la limite de 5 */
    var current = (cart.discount_codes || []).map(function (d) { return upper(d.code || d); }).filter(Boolean);
    var customer = current.filter(function (c) { return !managed[c]; });
    var finalCodes = customer.slice(), dropped = [];
    wanted.forEach(function (c) { if (finalCodes.indexOf(c) !== -1) return; if (finalCodes.length < MAX_CODES) finalCodes.push(c); else dropped.push(c); });
    var sameCodes = finalCodes.length === current.length && finalCodes.every(function (c) { return current.indexOf(c) !== -1; });
    Object.keys(updates).forEach(function (k) { var l = lines.filter(function (x) { return x.key === k; })[0]; if (l && l.quantity === updates[k]) delete updates[k]; });
    return { updates: updates, adds: merged, codes: finalCodes, discount: sameCodes ? null : finalCodes.join(','), qty: qty, dropped: dropped,
             changed: !sameCodes || Object.keys(updates).length > 0 || merged.length > 0 };
  }
  /* Expansion d'une variante pack (formulaire produit) en tubes réels. */
  function expand(cfg, id, quantity, properties, tones) {
    var o = null; (cfg.offers || []).forEach(function (x) { if (x.normalize && x.normalize[String(id)]) o = x; });
    if (!o) return null;
    var rule = o.normalize[String(id)], base = {};
    Object.keys(properties || {}).forEach(function (k) { if (!/^Tono \d+$/.test(k) && k.indexOf('_rr_') !== 0) base[k] = properties[k]; });
    var items = [];
    if (Array.isArray(rule)) {
      var total = 0; rule.forEach(function (r) { total += r[1]; });
      if (tones && tones.length === total) { /* tons choisis sur la PDP (Tinte Labial) */
        var tm = {}; tones.forEach(function (t) { tm[t] = (tm[t] || 0) + 1; });
        var unitByTone = {};
        Object.keys(o.normalize).forEach(function (k) { var r = o.normalize[k]; if (r && r.tones) Object.keys(r.tones).forEach(function (t) { unitByTone[t] = r.tones[t]; }); });
        if (Object.keys(tm).every(function (t) { return unitByTone[t]; })) rule = Object.keys(tm).map(function (t) { return [unitByTone[t], tm[t]]; });
      }
      rule.forEach(function (r) { if (r[1]) { var pr = {}; Object.keys(base).forEach(function (k) { pr[k] = base[k]; }); Object.keys(r[2] || {}).forEach(function (k) { pr[k] = r[2][k]; }); items.push({ id: Number(r[0]), quantity: r[1] * quantity, properties: pr }); } });
    }
    return items.length ? items : null;
  }
  var core = { plan: plan, expand: expand, codeFor: codeFor };
  if (typeof module !== 'undefined' && module.exports) module.exports = core;
  if (!root || !root.document || root.RorilioOffers) return;

  /* ---------- navigateur ---------- */
  var w = root, doc = w.document, cfg;
  try { cfg = JSON.parse(doc.getElementById('rorilio-offers-config').textContent); } catch (e) { cfg = w.RorilioOffersConfig; }
  if (!cfg || !cfg.offers) { console.warn('[rorilio-offers] config absente'); return; }
  var nativeFetch = w.fetch.bind(w), SECTIONS = 'cart-drawer,cart-icon-bubble', internal = 0;
  function base() { return (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/'; }
  function call(path, body) {
    internal++;
    return nativeFetch(base() + path, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) { var e = new Error(j.description || j.message || 'Error'); e.data = j; throw e; } return j; }); })
      .finally(function () { internal--; });
  }
  function checkout(off) {
    doc.querySelectorAll('#CartDrawer-Checkout, #checkout, [name="checkout"]').forEach(function (b) { if (off) b.setAttribute('disabled', ''); else b.removeAttribute('disabled'); });
  }
  function open(state) {
    var d = doc.querySelector('cart-drawer');
    if (d && d.renderContents && state && state.sections) {
      var wasOpen = d.classList.contains('active');
      if (state.item_count || (state.items && state.items.length)) d.classList.remove('is-empty');
      d.renderContents(state);
      if (!wasOpen && state._silent) d.close && d.close();
      return true;
    }
    return false;
  }
  function render(state) {
    if (location.pathname.replace(/\/$/, '').slice(-5) === '/cart') { location.reload(); return; }
    state._silent = true; open(state);
    if (typeof w.publish === 'function' && w.PUB_SUB_EVENTS) w.publish(w.PUB_SUB_EVENTS.cartUpdate, { source: 'rorilio-offers', cartData: state });
    doc.dispatchEvent(new CustomEvent('rorilio-offers:cart', { detail: state }));
  }
  var running = null, queued = false;
  function reconcile(withSections) {
    if (running) { queued = true; return running; }
    checkout(true);
    var pass = 0;
    function once(cart) {
      var p = plan(cart, cfg);
      if (p.dropped.length) console.warn('[rorilio-offers] limite de 5 codes : non posés', p.dropped);
      if (!p.changed || pass++ > 1) return withSections && !cart.sections ? call('cart/update.js', { updates: {}, sections: SECTIONS, sections_url: location.pathname }) : cart;
      var step = p.adds.length ? call('cart/add.js', { items: p.adds }) : Promise.resolve();
      return step.then(function () {
        var body = { updates: p.updates, sections: SECTIONS, sections_url: location.pathname };
        if (p.discount !== null) body.discount = p.discount;
        return call('cart/update.js', body);
      }).then(function (state) { render(state); return once(state); });
    }
    running = call('cart.js').then(once)
      .catch(function (e) { console.warn('[rorilio-offers]', e); })
      .then(function (state) { running = null; checkout(false); if (queued) { queued = false; return reconcile(withSections); } return state; });
    return running;
  }
  /* un seul hook fetch : toute écriture panier du thème -> une réconciliation (anti-rebond 150 ms) */
  var timer;
  w.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    /* les appels du moteur passent par nativeFetch : tout ce qui arrive ici vient du thème, jamais ignoré (29/10 : ajout SlimFlex perdu pendant la réconciliation de chargement) */
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      checkout(true);
      p.then(function () { clearTimeout(timer); timer = setTimeout(reconcile, 150); }, function () { checkout(false); });
    }
    return p;
  };
  /* Ajout depuis une PDP : nombre d'unités de l'offre, ou liste [{id, quantity, properties}] */
  function addPack(offerId) {
    return function (arg) {
      var o = cfg.offers.filter(function (x) { return x.id === offerId; })[0];
      var items = Array.isArray(arg) ? arg : [{ id: o.unit, quantity: Number(arg) || 1 }];
      return call('cart/add.js', { items: items }).then(function () { return reconcile(true); });
    };
  }
  function shim(offerId) { return { addPack: addPack(offerId), reconcile: function () { return reconcile(true); }, open: open }; }
  w.RorilioOffers = { config: cfg, plan: function (c) { return plan(c, cfg); }, reconcile: reconcile, open: open };
  /* compatibilité avec les PDP existantes (aucune modification de leurs scripts) */
  w.RorilioPdrnCart = shim('balsamo'); w.RorilioCaqui = shim('caqui'); w.RorilioSeamossCart = shim('seamoss');
  w.RorilioLashBCart = shim('pestanas_b'); w.RorilioBrowBCart = shim('cejas'); w.RorilioFacewrapCart = shim('facewrap');
  w.RorilioLymphCart = shim('lymph'); w.RorilioFennkoCart = shim('renacimiento'); w.RorilioEscGift = shim('escaner');
  /* product-form.js appelle RorilioBogo.prepare(formData) : variante pack -> tubes réels */
  function formTones(form) {
    var node = form && form.closest && form.closest('[data-lip-product]'), act = node && node.querySelector('[data-pack].is-selected');
    return act ? Array.prototype.map.call(act.querySelectorAll('select'), function (s) { return s.value; }) : null;
  }
  w.RorilioBogo = {
    config: cfg,
    expand: function (id, q, props) { return expand(cfg, id, q || 1, props || {}, null); },
    prepare: function (fd) {
      var props = {}; fd.forEach(function (v, k) { if (/^properties\[.*\]$/.test(k)) props[k.slice(11, -1)] = v; });
      var items = expand(cfg, fd.get('id'), Number(fd.get('quantity')) || 1, props, formTones(fd._rrForm));
      if (!items) return null;
      var out = { items: items };
      if (fd.has('sections')) { out.sections = String(fd.get('sections')).split(','); out.sections_url = fd.get('sections_url') || location.pathname; }
      return out;
    }
  };
  /* Filet de sécurité : jamais de checkout sans réconciliation (ajout par un script qui contourne le hook, clic rapide). */
  var leaving = false;
  doc.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('#CartDrawer-Checkout, #checkout, [name="checkout"], a[href*="/checkout"]');
    if (!b || leaving) return;
    e.preventDefault(); e.stopImmediatePropagation();
    leaving = true;
    var go = function () { location.href = base() + 'checkout'; };
    Promise.resolve(running).then(function () { return reconcile(); }).then(go, go);
  }, true);
  function boot() { reconcile(); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
  w.addEventListener('pageshow', function (e) { if (e.persisted) { leaving = false; reconcile(); } });
})(typeof window !== 'undefined' ? window : null);
